module.exports = __webpack_public_path__ + "img/group-logo-symbol.76936833.svg";